import Vue from "vue";
import Vuex from "vuex";

// Modules
import auth from "../store/modules/auth";
import user from "../store/modules/user";
import route from "../store/modules/route";
import product from "../store/modules/product";
import productCart from "../store/modules/cart";
import productWholesale from "../store/modules/wholesale";
import displayMode from "../store/modules/displayMode";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    user,
    route,
    product,
    productCart,
    productWholesale,
    displayMode,
  },
});
export default store;
